import { WorkingHours } from 'containers/Profile/Content/Information/Information';

export default class Address {
  text: string;
  latitude: number;
  longitude: number;
  postalCode: string;
  phoneNumber: string;
  workingHours: WorkingHours;

  constructor(
    text: string,
    latitude: number,
    longitude: number,
    postalCode: string,
    phoneNumber: string,
    workingHours: WorkingHours
  ) {
    this.text = text;
    this.latitude = latitude;
    this.longitude = longitude;
    this.postalCode = postalCode;
    this.phoneNumber = phoneNumber;
    this.workingHours = workingHours;
  }
}
